import { h, resolveComponent } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/campaigns/list',
    meta: { requiresAuth: true },
    children: [
      {
        path: '/campaigns',
        name: 'Campaigns',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/campaigns/list',
        children: [
          {
            path: '/campaigns/list',
            name: 'Campaigns List',
            component: () => import('@/views/campaigns/CampaignsList.vue'),
          },
          {
            path: '/campaigns/create',
            name: 'Create Campaign',
            component: () => import('@/views/campaigns/CampaignsEdit.vue'),
          },
          {
            path: '/campaigns/follow-up',
            name: 'Follow Up',
            component: () => import('@/views/campaigns/CampaignsFollowUp.vue'),
          },
          {
            path: '/campaigns/edit/:id',
            name: 'Edit Campaign',
            component: () => import('@/views/campaigns/CampaignsEdit.vue'),
          },
          {
            path: '/campaigns/send/:id',
            name: 'Send Campaign',
            component: () => import('@/views/campaigns/CampaignsSend.vue'),
          },
        ],
      },
      {
        path: '/senders',
        name: 'Senders',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/senders/list',
        children: [
          {
            path: '/senders/list',
            name: 'Senders List',
            component: () => import('@/views/senders/SendersList.vue'),
          },
          {
            path: '/senders/edit/:id',
            name: 'Edit Sender',
            component: () => import('@/views/senders/SendersEdit.vue'),
          },
          {
            path: '/senders/add/',
            name: 'Add Sender',
            component: () => import('@/views/senders/SendersEdit.vue'),
          },
        ],
      },
      {
        path: '/templates',
        name: 'Templates',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/templates/list',
        children: [
          {
            path: '/templates/list',
            name: 'Templates List',
            component: () => import('@/views/templates/TemplatesList.vue'),
          },
          {
            path: '/templates/add',
            name: 'Add Template',
            component: () => import('@/views/templates/TemplatesView.vue'),
          },
          {
            path: '/templates/view/:id',
            name: 'View Template',
            component: () => import('@/views/templates/TemplatesView.vue'),
          },
        ],
      },
      {
        path: '/replies',
        name: 'Replies',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/replies/list',
        children: [
          {
            path: '/replies/add',
            name: 'Save Reply',
            component: () => import('@/views/replies/RepliesAdd.vue'),
          },
        ],
      },
      {
        path: '/meetings',
        name: 'Meetings',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/meetings/list',
        children: [
          {
            path: '/meetings/list',
            name: 'Meetings List',
            component: () => import('@/views/meetings/MeetingsList.vue'),
          },
          {
            path: '/meetings/report',
            name: 'Report Meeting',
            component: () => import('@/views/meetings/MeetingsReport.vue'),
          },
        ],
      },
      {
        path: '/hashids',
        name: 'Hashids',
        component: () => import('@/views/HashIds.vue'),
      },
      {
        path: '/docs',
        name: 'Docs',
        component: () => import('@/views/Docs.vue'),
      },
    ],
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const accessToken = localStorage.getItem('access_token')
    if (!accessToken) {
      next('/pages/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
